export default __webpack_public_path__ + "f032dd62840073731cda5cc3b9ab5762.png";